import React, { useEffect, useState } from "react";
import EnhancedGridTable from "../Table/Table";
import { EnhancedTableToolbar } from "./EnhancedAlertsTableHeader";
import page_loader from "../../../assets/vizr_images/page_loader.gif";
import { getAcceptedRisks } from "../../../redux/actions/getAcceptedRisk";

const EllipsisCell = ({ value, width = "160px" }) => (
  <div
    title={value}
    style={{
      maxWidth: width,
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "block",
      lineHeight: "18px",
      wordBreak: "break-word",
    }}
  >
    {value}
  </div>
);

export const acceptedRisksTableConstants = () => [
  {
    id: "acceptedBy",
    title: "Accepted By",
    sortable: true,
    render: (row) => <EllipsisCell value={row.acceptedBy} width="180px" />,
  },
  {
    id: "acceptedAt",
    title: "Accepted At",
    sortable: true,
    render: (row) => <EllipsisCell value={row.acceptedAt} width="170px" />,
  },
  {
    id: "acceptedTill",
    title: "Accepted Till",
    sortable: true,
    render: (row) => <EllipsisCell value={row.acceptedTill} width="170px" />,
  },
  {
    id: "reason",
    title: "Reason",
    sortable: false,
    render: (row) => <EllipsisCell value={row.reason} width="300px" />,
  },
  {
    id: "revokedAt",
    title: "Revoked At",
    sortable: true,
    render: (row) => <EllipsisCell value={row.revokedAt} width="170px" />,
  },
  {
    id: "revokedBy",
    title: "Revoked By",
    sortable: true,
    render: (row) => <EllipsisCell value={row.revokedBy} width="180px" />,
  },
];

const formatDate = (timestamp) => {
  if (!timestamp) return "-";

  const date = new Date(timestamp);

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${month}-${day}-${year} ${hours}:${minutes}`;
};

export default function AcceptedRisksTable(props) {
  const { alertDetailsId, project } = props;

  const [acceptedRisks, setAcceptedRisks] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!alertDetailsId) return;

    fetchAcceptedRisks();

    return () => {
      setAcceptedRisks([]);
    };
  }, [alertDetailsId]);

  useEffect(() => {
    if (!alertDetailsId) return;

    fetchAcceptedRisks();
  }, [currentPage, recordsPerPage]);

  const fetchAcceptedRisks = async () => {
    setLoader(true);

    const response = await getAcceptedRisks(
      alertDetailsId,
      recordsPerPage,
      currentPage,
    );

    if (response) {
      const formattedRows = response.content.map((item, index) => ({
        id: `${item.acceptedAt}-${index}`,

        acceptedBy: item.acceptedBy || "-",
        acceptedAt: formatDate(item.acceptedAt),
        acceptedTill: formatDate(item.acceptedTill),
        reason: item.reason || "-",
        revokedAt: formatDate(item.revokedAt),
        revokedBy: item.revokedBy || "-",
      }));

      setAcceptedRisks(formattedRows);
      setTotalCount(response.totalElements || 0);
    }

    setLoader(false);
  };

  const handleChangeRowsPerPage = (value) => {
    setCurrentPage(0);
    setRecordsPerPage(value);
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  return (
    <div style={{ position: "relative" }}>
      {loader && (
        <img
          src={page_loader}
          alt="loading"
          style={{
            position: "absolute",
            marginLeft: "172px",
            top: "120px",
            zIndex: 5,
          }}
        />
      )}

      <EnhancedTableToolbar
        totalElements={totalCount}
        loc="accepted-risks"
        alertsTitle="Accepted Risks"
        selectedRows={[]}
        rows={acceptedRisks}
        hideAction={true}
      />

      <EnhancedGridTable
        cols={acceptedRisksTableConstants()}
        data={acceptedRisks}
        totalCount={totalCount}
        currentPage={currentPage}
        recordsPerPage={recordsPerPage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onChangePage={handleChangePage}
        project={project}
      />
    </div>
  );
}
